import type { LC_HolidayTypeItemOut, HolidayType } from './holidayType.types';


export function mapHolidayTypeToModel(raw: LC_HolidayTypeItemOut): HolidayType {
  return {
    id: raw.holidayTypeId,
    name: raw.name ?? '',
  };
}
